/* eslint-disable func-names */
/* eslint-disable no-undef */
/* eslint-disable prefer-rest-params */

// Toggle the Qualified messenger iframe: visible only while the meeting modal
// is full-screen, hidden otherwise (suppresses the persistent talk bubble).
const observeQualifiedIframe = (iframe) => {
  const attributeObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === 'class') {
        const meetingModalVisible = mutation.target
          .getAttribute('class')
          .includes('qlfd-full-screen');

        mutation.target.style.setProperty(
          'display',
          meetingModalVisible ? 'block' : 'none',
          'important',
        );
      }
    });
  });

  attributeObserver.observe(iframe, { attributes: true });
};

const setupQualifiedIframeObserver = () => {
  // The messenger iframe may already exist if the Qualified script loaded
  // before this setup ran (e.g. when the chat is loaded after page load).
  const existingFrame = document.getElementById('q-messenger-frame');
  if (existingFrame) {
    observeQualifiedIframe(existingFrame);
    return;
  }

  // Observe first level DOM node mutations for the messenger iframe.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.tagName === 'IFRAME' && node.id === 'q-messenger-frame') {
          observeQualifiedIframe(node);
          observer.disconnect();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true });
};

export const loadQualifiedDocsChat = () => {
  ((w, d) => {
    if (w.QualifiedObject) {
      return;
    }
    const head = d.getElementsByTagName('head')[0];
    const script = d.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://js.qualified.com/qualified.js?token=gfwXVGcrnd6984yB';
    head.appendChild(script);
    (function (w, q) {
      w.QualifiedObject = q;
      w[q] =
        w[q] ||
        function () {
          (w[q].q = w[q].q || []).push(arguments);
        };
    })(w, 'qualified');
  })(window, document);

  if (typeof qualified !== 'undefined') {
    qualified('handleEvents', (name, data) => {
      window.rudderanalytics.track(name, data);
    });
  }

  // The chat can be loaded after `DOMContentLoaded` (it now loads post-login),
  // in which case the event has already fired — run the setup immediately.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupQualifiedIframeObserver);
  } else {
    setupQualifiedIframeObserver();
  }
};
